import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M14_TOPICS, M14_MODULE_INFO } from '../data/mathExercises/M14_Mensuration';

// Create mock problems data for M14
const M14_PROBLEMS_DATA = {
  'M14_01': [
    {
      id: 'M14_01_P001',
      topicId: 'M14_01',
      question: "矩形的長為 8cm，寬為 5cm，求面積",
      solution: "40 cm²",
      explanation: "使用矩形面積公式",
      difficulty: 1,
      order: 1,
      steps: ["矩形面積 = 長 × 寬", "面積 = 8 × 5", "面積 = 40 cm²"]
    },
    {
      id: 'M14_01_P002',
      topicId: 'M14_01',
      question: "三角形的底邊為 12cm，高為 8cm，求面積",
      solution: "48 cm²",
      explanation: "使用三角形面積公式",
      difficulty: 1,
      order: 2,
      steps: ["三角形面積 = (1/2) × 底 × 高", "面積 = (1/2) × 12 × 8", "面積 = 48 cm²"]
    }
  ],
  'M14_02': [
    {
      id: 'M14_02_P001',
      topicId: 'M14_02',
      question: "圓的半徑為 7cm，求圓的面積",
      solution: "49π cm²",
      explanation: "使用圓面積公式",
      difficulty: 1,
      order: 1,
      steps: ["圓面積 = πr²", "代入 r = 7", "面積 = π × 7² = 49π cm²"]
    },
    {
      id: 'M14_02_P002',
      topicId: 'M14_02',
      question: "扇形的半徑為 6cm，圓心角為 120°，求扇形面積",
      solution: "12π cm²",
      explanation: "使用扇形面積公式",
      difficulty: 2,
      order: 2,
      steps: ["扇形面積 = (θ/360°) × πr²", "代入 θ = 120°, r = 6", "面積 = (120°/360°) × π × 36 = 12π cm²"]
    }
  ],
  'M14_03': [
    {
      id: 'M14_03_P001',
      topicId: 'M14_03',
      question: "長方體的長、寬、高分別為 6cm、4cm、3cm，求體積",
      solution: "72 cm³",
      explanation: "使用長方體體積公式",
      difficulty: 1,
      order: 1,
      steps: ["長方體體積 = 長 × 寬 × 高", "體積 = 6 × 4 × 3", "體積 = 72 cm³"]
    },
    {
      id: 'M14_03_P002',
      topicId: 'M14_03',
      question: "圓柱的底面半徑為 5cm，高為 12cm，求體積",
      solution: "300π cm³",
      explanation: "使用圓柱體積公式",
      difficulty: 2,
      order: 2,
      steps: ["圓柱體積 = πr²h", "代入 r = 5, h = 12", "體積 = π × 25 × 12 = 300π cm³"]
    }
  ],
  'M14_04': [
    {
      id: 'M14_04_P001',
      topicId: 'M14_04',
      question: "正方體的邊長為 4cm，求表面積",
      solution: "96 cm²",
      explanation: "正方體有 6 個相同的正方形面",
      difficulty: 1,
      order: 1,
      steps: ["正方體表面積 = 6 × 邊長²", "表面積 = 6 × 4²", "表面積 = 6 × 16 = 96 cm²"]
    }
  ],
  'M14_05': [
    {
      id: 'M14_05_P001',
      topicId: 'M14_05',
      question: "一個 L 形圖形由兩個矩形組成：6×4 和 3×2，求總面積",
      solution: "30 cm²",
      explanation: "複合圖形分解為基本圖形",
      difficulty: 2,
      order: 1,
      steps: ["第一個矩形面積 = 6 × 4 = 24 cm²", "第二個矩形面積 = 3 × 2 = 6 cm²", "總面積 = 24 + 6 = 30 cm²"]
    }
  ],
  'M14_06': [
    {
      id: 'M14_06_P001',
      topicId: 'M14_06',
      question: "房間長 4m，寬 3m，要鋪地磚，每塊地磚 20cm × 20cm，需要多少塊？",
      solution: "300 塊",
      explanation: "實際應用中的面積計算",
      difficulty: 2,
      order: 1,
      steps: ["房間面積 = 4 × 3 = 12 m² = 120000 cm²", "每塊地磚面積 = 20 × 20 = 400 cm²", "需要地磚數 = 120000 ÷ 400 = 300 塊"]
    }
  ]
};

const M14MensurationExercise = ({ onProgress }) => {
  // Convert problemsData to flat problems array
  const problems = Object.values(M14_PROBLEMS_DATA).flat();
  
  return (
    <ExerciseInterface
      moduleInfo={M14_MODULE_INFO}
      topics={M14_TOPICS}
      problems={problems}
      onProgress={onProgress}
      className="m14-exercise"
    />
  );
};

export default M14MensurationExercise; 